import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import AuditLog from './AuditLog';
import {
  selectAuditEntries,
  selectAuditLoading,
  selectAuditError,
  selectAuditLoaded,
} from '../../../redux/reducers/eligibility.selectors';
import { fetchAuditEntries } from '../../../redux/actions/eligibility.actions';

const AuditLogContainer = ({ entries, isLoading, error, loaded, onLoad }) => {
  useEffect(() => {
    if (!loaded) onLoad();
  }, [onLoad, loaded]);

  return <AuditLog entries={entries} isLoading={isLoading} error={error} />;
};

const mapStateToProps = state => ({
  entries: selectAuditEntries(state),
  isLoading: selectAuditLoading(state),
  error: selectAuditError(state),
  loaded: selectAuditLoaded(state),
});

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(fetchAuditEntries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogContainer);
